import { createContext } from 'react';
import type { EigenWekenoverzicht } from './work-quality.api';

/**
 * Wat de pagina over het overzicht over weken weet (SPEC-meerweekenoverzicht-feedback CAP-6).
 *
 * De pagina vraagt het één keer op en elke leerkaart leest hieruit zijn eigen veld en werksoort. `weken`
 * zijn de vier gevraagde sleutels, oudste eerst: daaruit komen de vaste plekken, niet uit het antwoord.
 */
export type TrendLezing =
  | { status: 'laden' }
  | { status: 'fout' }
  | { status: 'klaar'; overzicht: EigenWekenoverzicht; weken: readonly string[] };

/** Zonder bron (`null`) toont de kaart de storingstekst: nooit een grafiek uit het niets (AD-27). */
export const TrendContext = createContext<TrendLezing | null>(null);
